<template>
  <div>
    <table-title>筛选框</table-title>
    <el-form ref="queryParamsRef" :model="queryParams" inline label-width="110px" :rules="rules">
      <el-form-item label="业务类型" prop="type">
        <plt-dict-select v-model="queryParams.type" namespace="ENUM_MID-OPERATE-LEASE" id="queryService.BusinessType" />
      </el-form-item>
      <el-form-item label="交付计划编号">
        <el-input style="width:200px" placeholder="请输入" v-model="queryParams.id" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="客户名称">
        <plt-biz-select v-model="queryParams.customerId" url="CORE-MEMBER/messageService/memberCustomerService/queryCustomerByMemberId" :params="{roleId: 'MEMBER_CUSTOMER'}" />
      </el-form-item> -->
      <el-form-item label="仓库名称">
        <plt-biz-select v-model="queryParams.storageId" textField="storageName" codeField="storageId" url="http://MID-OPERATE-LOGISTICS/messageService/queryService/queryManagerStorageInfo" :params="{}" />
      </el-form-item>
      <el-form-item label="状态">
        <plt-dict-select v-model="queryParams.status" namespace="ENUM_MID-OPERATE-LEASE" id="leaseDeliveryPlan.DeliveryPlanStatus" :include='["NORMAL", "FINISH"]' />
      </el-form-item>
      <el-button type="primary" @click="onQuery">查询</el-button>
    </el-form>
    <plt-table ref="tableRef" :url="queryUrl" paramName="param" :queryParams="queryParams">
      <el-table-column label="交付计划编号" prop="id" />
      <plt-table-dict-col label="客户名称" prop="customerId" namespace="bizObjects" id="member" />
      <plt-table-dict-col label="标的物小类" prop="targetType" namespace="target" id="type" />
      <plt-table-dict-col label="标的物编码" prop="targetCode" namespace="target" id="targetCodeUnion" width="230px" />
      <plt-table-dict-col label="仓库名称" prop="storageId" namespace="bizObjects" id="warehouse" />
      <plt-table-dict-col label="联系人" prop="contactId" namespace="bizObjects" id="contact" />
      <plt-table-dict-col label="品质类型" prop="qualityType" namespace="ENUM_CORE-STORAGE" id="operateService.QualityType" />
      <plt-table-dict-col label="用途类型" prop="useType" namespace="ENUM_CORE-STORAGE" id="operateService.UseType" />
      <el-table-column label="总数量" prop="totalAmount" />
      <el-table-column label="交付数量" prop="finishAmount" />
      <plt-table-dict-col label="状态" prop="status" namespace="ENUM_MID-OPERATE-LEASE" id="leaseDeliveryPlan.DeliveryPlanStatus" />
      <el-table-column label="操作">
        <template #default="{row}">
          <el-button type="success" size="small" v-if="row.status === 'NORMAL' && row.finishAmount != row.totalAmount" @click="stockRemoval(row)">自提确认</el-button>
        </template>
      </el-table-column>
    </plt-table>
    <stock-removal ref="stockRemValRef" @search="onQuery"/>
    <trade-stock-removal ref="tradeStockRemovalRef" @search="onQuery"/>
  </div>
</template>

<script>
import stockRemoval from './component/stockRemoval.vue'
import tradeStockRemoval from './component/tradeStockRemoval.vue'
export default {
  components: { stockRemoval,tradeStockRemoval },
  data() {
    return {
      queryUrl: "http://MID-OPERATE-LEASE/messageService/queryService/queryStorageManagerSelfMention",
      queryParams: {
        type: "LEASE"
      },
      rules: {
        type: [{ required: true, message: "请选择" }]
      }
    }
  },
  methods: {
    async onQuery() {
      let validate = await this.$refs['queryParamsRef'].validate();
      if (!validate) return;
      this.$refs['tableRef'].loadFirstPage();
    },
    // 自提确认
    stockRemoval(data) {
      if (data.type === 'LEASE') {
        this.$refs["stockRemValRef"].openModal(data);
      }else if(data.type == 'TRADE'){
        data.title='自提出库确认'
        this.$refs["tradeStockRemovalRef"].openModal(data);

      }
    },
  }

}
</script>

<style>
</style>